import { useMutation } from "@tanstack/react-query";
import { loginApiRequest } from "../../services";
import { TLogin } from "../../types";

export const useLoginApi = () => {
    return useMutation({
        mutationFn: (loginInfo: TLogin) => loginApiRequest(loginInfo), 
    })
}